import { render, staticRenderFns } from "./bill_container.vue?vue&type=template&id=08712ab9"
import script from "./bill_container.vue?vue&type=script&lang=js"
export * from "./bill_container.vue?vue&type=script&lang=js"
import style0 from "./bill_container.vue?vue&type=style&index=0&id=08712ab9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports